<template>
  <section class="pageContents">
    <div class="pageContents-text container">
      <UserView />
    </div>
  </section>

</template>

<script src="./start.ts"/>